import React from 'react'
import { useDispatch } from 'react-redux'
import { useTable } from 'hooks'
import { getColumns } from './model'
import { toUserDepartments } from 'ducks/router'

import { fetchUserDepartments } from 'api/users'

const useUserDepartmentTableMutations = () => {
  const [data, setData] = React.useState(false)

  const handleFetchDepartments = React.useCallback(
    async (pk, { limit, offset }) => {
      const { response } = await fetchUserDepartments(pk, { limit, offset })
      setData(response)
    },
    [fetchUserDepartments, setData],
  )

  return {
    handleFetchDepartments,
    data,
  }
}

export const useUserDepartmentsTable = state => {
  const { mapSortingPropToQueryParam, search, user, signalTableUpdate } = state

  const columns = getColumns()

  const dispatch = useDispatch()

  const { handleFetchDepartments, data } = useUserDepartmentTableMutations()

  const handleRefetch = React.useCallback(
    ({ limit, offset }) => {
      handleFetchDepartments(user, { limit, offset })
    },
    [handleFetchDepartments, user, signalTableUpdate],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, offset }) => {
      dispatch(toUserDepartments({ pk: user, query: { limit, offset } }))
    },
    [dispatch, user, toUserDepartments],
  )

  const goToProjects = React.useCallback(
    departmentId => {
      dispatch(
        toUserDepartments({
          pk: user,
          id: departmentId,
          query: { limit: 7, offset: 0 },
        }),
      )
    },
    [dispatch, toUserDepartments, user],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: data.results,
    mapSortingPropToQueryParam,
    pageCount: data.count,
    defaultPageSize: 15,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  React.useEffect(() => {
    if (user) {
      handlePage(0)
    }
  }, [user])

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
      goToProjects,
    },
  }
}
